import { render, staticRenderFns } from "./BoardDetailItem.vue?vue&type=template&id=3811b82e&scoped=true"
import script from "./BoardDetailItem.vue?vue&type=script&lang=js"
export * from "./BoardDetailItem.vue?vue&type=script&lang=js"
import style0 from "./BoardDetailItem.vue?vue&type=style&index=0&id=3811b82e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3811b82e",
  null
  
)

export default component.exports